import { getMetaContentMaybe } from "~/common/get-meta-content"
import { AppText } from "~/ui/app-text"

export const getBbBattleRoyaleUrl = () => getMetaContentMaybe("bb-battle-royale-url")

const displayUrl = (url: string) => url.replace(/^https?:\/\//, "").replace(/\/$/, "")

export const BbBattleRoyaleBanner = (): JSX.Element | null => {
  const url = getBbBattleRoyaleUrl()
  if (!url) return null

  return (
    <AppText variant="body2" className="text-center font-bold text-base-white">
      Watch BB Battle Royale LIVE at 4pm PT:{" "}
      <a href={url} target="_blank" rel="noopener noreferrer" className="underline">
        {displayUrl(url)}
      </a>
    </AppText>
  )
}
